// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RDihdr2xiQYtCvoNl4VT{margin-right:-22px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/ui/BillingPlan/store/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".labelRight {\n  margin-right: -22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelRight": `RDihdr2xiQYtCvoNl4VT`
};
export default ___CSS_LOADER_EXPORT___;
